import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function MonitoringMy() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">찾기 힘든 지도속 내 매물!<br />리스트로 편리하게 보고 노출순위도 쉽게 확인해요</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<ol className="list_order"><li><h4 className="order_title text_primary">네이버 모니터링</h4><p className="order_desc">하나 하나 묶어서 찾아야 하는 내 매물 불편하지 않으셨나요?</p><Image className="img_guide" src="/image/mobile/popup/monitoring02_01.png" alt={"\uACE0\uAC1D\uBCC4\uB85C \uACFC\uAC70\uBD80\uD130 \uD604\uC7AC\uAE4C\uC9C0 \uBAA8\uB4E0 \uC0C1\uB2F4 \uB0B4\uC5ED\uC744 \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694"} width={100} height={100} /></li><li><h4 className="order_title text_primary">이실장</h4><p className="order_desc">내 매물의 네이버 노출순위를 리스트로 편리하게 확인할 수 있어요</p><Image className="img_guide" src="/image/mobile/popup/monitoring02_02.png" alt={"\uCDA9\uC804\uAE08\uC774 \uC801\uC6A9\uB418\uC5C8\uC5B4\uC694."} width={100} height={100} /></li><li><p className="order_desc">타 중개업소의 노출 순위도 한눈에 확인이 가능해요</p><Image className="img_guide" src="/image/mobile/popup/monitoring02_03.png" alt={"\uCDA9\uC804\uAE08\uC774 \uC801\uC6A9\uB418\uC5C8\uC5B4\uC694."} width={100} height={100} /></li></ol></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}